import React, { useContext, useEffect } from 'react';
import { Typography, Card } from '@arco-design/web-react';
import locale from './locale';
import useLocale from '@/utils/useLocale';
import { standalonePagesStyles as styles } from '@/style';
import { GlobalContext } from '@/context';
import Logo from '@/assets/logo.svg';
import PageTitle from '@/components/PageTitle';
import { useHistory } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

function PrivacyPolicy() {
  const t = useLocale(locale);
  const { theme } = useContext(GlobalContext) || { theme: 'light' };
  const history = useHistory();

  useEffect(() => {
    document.body.setAttribute('arco-theme', theme || 'light');
  }, [theme]);

  return (
    <div className={styles.standalone}>
      <PageTitle titleKey="menu.privacyPolicy" />
      <div className={styles.header}>
        <a
          href="https://www.suwendata.com/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.logoContainer}
          style={{ cursor: 'pointer', textDecoration: 'none' }}
        >
          <Logo />
          {/* <span className={styles.logoText}>速问</span> */}
        </a>
      </div>

      <div className={styles.container}>
        <Card className={styles.card}>
          <Title heading={2} className={styles.mainTitle}>
            {t['privacy.title']}
          </Title>

          <Paragraph className={styles.intro}>{t['privacy.intro']}</Paragraph>

          <Paragraph className={styles.intro}>
            {t['privacy.readAgreement']}
          </Paragraph>

          <Paragraph className={styles.helpContent}>
            {t['privacy.helpContent']}
          </Paragraph>

          <div className={styles.section}>
            <Title heading={4}>{t['privacy.section1.title']}</Title>
            <Paragraph>{t['privacy.section1.content1']}</Paragraph>
            <Paragraph>{t['privacy.section1.content2']}</Paragraph>
            <Paragraph>{t['privacy.section1.content3']}</Paragraph>
            <ul className={styles.list}>
              <li>{t['privacy.section1.list.item1']}</li>
              <li>{t['privacy.section1.list.item2']}</li>
              <li>{t['privacy.section1.list.item3']}</li>
              <li>{t['privacy.section1.list.item4']}</li>
            </ul>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['privacy.section2.title']}</Title>
            <Paragraph>{t['privacy.section2.content1']}</Paragraph>
            <Paragraph>{t['privacy.section2.content2']}</Paragraph>
            <Paragraph>{t['privacy.section2.content3']}</Paragraph>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['privacy.section3.title']}</Title>
            <Paragraph>{t['privacy.section3.content1']}</Paragraph>
            <Paragraph>{t['privacy.section3.content2']}</Paragraph>
            <Paragraph>{t['privacy.section3.content3']}</Paragraph>
            <ul className={styles.list}>
              <li>{t['privacy.section3.list.item1']}</li>
              <li>{t['privacy.section3.list.item2']}</li>
              <li>{t['privacy.section3.list.item3']}</li>
              <li>{t['privacy.section3.list.item4']}</li>
              <li>{t['privacy.section3.list.item5']}</li>
              <li>{t['privacy.section3.list.item6']}</li>
              <li>{t['privacy.section3.list.item7']}</li>
              <li>{t['privacy.section3.list.item8']}</li>
            </ul>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['privacy.section4.title']}</Title>
            <Paragraph>{t['privacy.section4.content1']}</Paragraph>
            <Paragraph>{t['privacy.section4.content2']}</Paragraph>
          </div>

          <div className={styles.section}>
            <Title heading={4}>{t['privacy.section5.title']}</Title>

            <Title heading={5}>{t['privacy.section5.subtitle1']}</Title>
            <Paragraph>{t['privacy.section5.content1']}</Paragraph>
            <Paragraph>{t['privacy.section5.content2']}</Paragraph>
            <ul className={styles.list}>
              <li>{t['privacy.section5.list1.item1']}</li>
              <li>{t['privacy.section5.list1.item2']}</li>
              <li>{t['privacy.section5.list1.item3']}</li>
            </ul>

            <Title heading={5}>{t['privacy.section5.subtitle2']}</Title>
            <Paragraph>{t['privacy.section5.content3']}</Paragraph>

            <Paragraph className={styles.subsection}>
              <b>{t['privacy.section5.subtitle2.1']}</b>
              <Paragraph>{t['privacy.section5.content4']}</Paragraph>
              <Paragraph>{t['privacy.section5.content5']}</Paragraph>
            </Paragraph>

            <Paragraph className={styles.subsection}>
              <b>{t['privacy.section5.subtitle2.2']}</b>
              <Paragraph>{t['privacy.section5.content6']}</Paragraph>
              <Paragraph>{t['privacy.section5.content7']}</Paragraph>
            </Paragraph>

            <Paragraph className={styles.subsection}>
              <b>{t['privacy.section5.subtitle2.3']}</b>
              <Paragraph>{t['privacy.section5.content8']}</Paragraph>
              <Paragraph>{t['privacy.section5.content9']}</Paragraph>
            </Paragraph>

            <Title heading={5}>{t['privacy.section5.subtitle3']}</Title>
            <Paragraph>{t['privacy.section5.content10']}</Paragraph>
          </div>

          <div className={styles.footer}>
            <Text bold>{t['privacy.footer.company']}</Text>
            <br />
            <Text>{t['privacy.footer.date']}</Text>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
